module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_8.b9433837.png";